import _Watermark from './watermark';
import { withInstall } from '@tdesign/shared-utils';

export * from './type';

export const Watermark = withInstall(_Watermark);
export default Watermark;
